
// Material Dashboard 2 React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderWidth } = borders;
const { light ,dark,primary,background,error} = colors;

const tableCell = {
  styleOverrides: {
    root: {
      boxShadow: 2,
      fontSize:'small',
      fontWeight:'normal',
      // textAlign: 'center',
      background:`#fff !important`,
      // padding: `${pxToRem(6)} ${pxToRem(8)}`,
      border: `${borderWidth[1]} solid ${light.main}`,
      '&:hover': {
        color: primary.light,
        cursor: 'pointer',
      },
      '&:focus': {
        outline: 'none',
        border: `1px solid ${primary.light}`,
      },

      '&[data-pinned="true"]': {
        fontWeight: 'bold', // 加粗字体
      },
      '&[data-pinned="true"]:before': {
        background: `#f8f8f8 !important`,

      },

      "&.error": {
        border: `2px solid ${error.main} !important`, // 红色边框
        backgroundColor: `${light.main} !important`, // 可选：修改背景颜色
      },


    },
  },
};

export default tableCell;
